import React from "react";

const EachFAQ = ({ question, answer }) => (
  <div className="each-faq">
    {question}
    <p>{answer}</p>
  </div>
);

export default EachFAQ;
